import { object, string, number } from 'yup';

export const quarantineValidation = () =>
  object().shape({
    deficientType: string().required('Deficient type required'),
    zoneId: string().required('Quarantine zone required')
  });
